import Nav from "./Nav"
import Hero from './Hero'
import TOAkbar from './TOAkbar'
import Features from './Features'
import Stats from './Stats'
import Teacher from './Teacher'
import Footer from './Footer'

function App() {
  return (
    <>
      <Nav />
      <Hero />
      <TOAkbar />
      <Features />
      <Stats />
      <Teacher />
      <Footer />
    </>
  );
}

export default App;

